import _ from 'core-cmp/lodash'
import { UDA_URL } from 'core-uda/model/ResourceDAO'
import FamilyModelPrefDAO from 'core-metoc/model/FamilyModelPrefDAO'
import MultiModel from 'core-metoc/model/multiLayer/MultiModel'
import DefaultModel from 'core-metoc/model/multiLayer/DefaultModel'
import { RIGHTS } from 'core-uda/Rights'
import modeMobilePositionDate, {
  listenChangeMetocDateWithPosition,
} from 'thm/model/metocMultiLayer/modeMobilePositionDate'
import modeSarSadDatumDate, {
  listenActiveSarSad,
} from 'thm/model/metocMultiLayer/modeSarSadDatumDate'
import modeCurrentDate from 'core-metoc/ui/multiLayer/modeCurrentDate'
import modeCustomDate from 'core-metoc/ui/multiLayer/modeCustomDate'

/**
 * Modèle de données Metoc gérant 3 couches de données :
 * - image : Donnée représentée sous la forme d'une image en dégardé de couleur.
 * - vector : Donnée vestorielle (vent, courant,...)
 * - isoligne : Donnée représentée sous la forme d'isolignes
 */
let ThmMultiMetocModel = MultiModel.extend({
  families: {},
  modelClazz: DefaultModel,
  config: null,
  models: null,

  /**
   * @override
   */
  init: function () {
    let me = this
    me.familyDao = new FamilyModelPrefDAO()
    me.attr('legends', [])
    me.model = {}
    me.config = {}
    me._super()
  },

  loadDatas: function () {
    this._super()

    this.additionalDateModes = []

    // Activate date mode "Mobile position"
    if (RIGHTS('metoc.followPos')) {
      this.additionalDateModes.push(modeMobilePositionDate)
      listenChangeMetocDateWithPosition()
    }

    // Activate date mode "Sar Sad"
    if (DATA_AUTHORIZED('searchAndRescue')) {
      this.additionalDateModes.push(modeSarSadDatumDate)
      listenActiveSarSad()
    }

    // Date mode list
    this.dateModes = [
      modeCurrentDate,
      modeCustomDate,
      ...this.additionalDateModes,
    ]

    // Update time when the date mode throws an event
    for (const dateModeItem of this.dateModes) {
      dateModeItem.subscribe((state, ev) => {
        const currentDateModeType = PREF('metocDateMode')
        if (ev.modeType !== currentDateModeType) return

        this.setTime(ev.date)
      })
    }

    // Update time when the date mode change
    PREF().on('metocDateMode', () => {
      const currentDateModeType = PREF('metocDateMode')
      const dateMode = this.dateModes.find(
        (d) => d.modeType === currentDateModeType,
      )

      if (dateMode) {
        const date = dateMode.getDate()
        this.dateType = dateMode.modelType
        if (date) this.setTime(date)
      }
    })
  },

  loadConfig: function (context) {
    const me = this,
      config = {
        models: {
          metoc: {
            families: [
              {
                id: 'image',
                index: 1,
                family: 'image',
                icon: 'griddedData',
                title: {
                  en: 'Picture',
                  fr: 'Image',
                },
              },
              {
                id: 'vector',
                index: 2,
                family: 'vector',
                icon: 'vectorData',
                title: {
                  en: 'Vector data',
                  fr: 'Données Vectorielles',
                },
              },
              {
                id: 'isoline',
                index: 3,
                family: 'isoline',
                icon: 'isoline',
                title: {
                  en: 'Isoline',
                  fr: 'Isoligne',
                },
              },
              {
                id: 'rawVector',
                index: 4,
                family: 'rawVector',
                icon: 'play',
                title: {
                  en: 'Streamlines',
                  fr: 'Filaments animés',
                },
              },
            ],
            groups: {},
            services: [{}],
          },
        },
      }

    // Generate uda proxy url
    _.each(context.wmsServices, (wmsService) => {
      wmsService.url = UDA_URL + 'map/metoc/' + wmsService.id
      wmsService.httpHeaders = {
        jwt: context.token,
        application: context.application,
      }
    })

    config.models.metoc.services = context.wmsServices

    me.setConfig(config)
  },

  getModelClass: function (id) {
    let me = this,
      clazz = me._super(id)

    if (id === 'others') {
      clazz = me.modelClazz
    }

    return clazz
  },
})

export default ThmMultiMetocModel
